import dayjs from 'dayjs';
import React from 'react';
import FormattedDate from '../../lib/FormattedDate/FormattedDate';

interface ICancellationPolicyProps {
  date?: string;
  onClick?: (e?: any) => void;
  title?: string;
}

const CancellationPolicy: React.FC<React.PropsWithChildren<React.PropsWithChildren<ICancellationPolicyProps>>> = ({
  onClick,
  title = 'COVID cancellation policy',
}) => {
  // const differenceInDate = React.useMemo(() => {
  //   return dayjs(date).endOf('d').diff(dayjs().startOf('d'), 'd');
  // }, [date]);

  // if (!differenceInDate || differenceInDate < 2) {
  //   return null;
  // }
  return (
    <div className="px-4 py-2 mb-6 text-gray-600 rounded-lg">
      {/* <span className="text-sm leading-tight">
        <>
          <span className="font-medium">FREE cancellation</span> before{' '}
          {differenceInDate >= 8 && (
            <FormattedDate
              date={dayjs(date)
                .startOf('d')
                .subtract(1, 'week')
                .format('YYYY-MM-DD')}
              readable
            />
          )}
          {differenceInDate < 8 && (
            <FormattedDate
              date={dayjs().startOf('d').add(1, 'day').format('YYYY-MM-DD')}
              readable
            />
          )}
          .{' '}
        </>

        <span>So lock in this great price today.</span>
      </span> */}
      <span
        onClick={onClick}
        className="inline-block w-full py-1 text-sm font-medium leading-tight text-center capitalize cursor-pointer"
      >
        {title}. <span className="underline">Learn more</span>
      </span>
    </div>
  );
};
export default CancellationPolicy;
